import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./EbookCard.module.css";

const EbookCard = ({ book }) => {
  const truncateSummary = (text) => {
    if (!text) return "";
    return text.length > 50 ? `${text.substring(0, 50)}...` : text;
  };

  // Check if this is a series or individual book
  const hasSeries = book.series_id && book.seriesInfo;
  const navigate = useNavigate();

  // Generate appropriate links based on whether it's a series or individual book
  const getReadNowLink = () => {
    if (hasSeries) {
      // For series: /book/:seriesid/episode/:chapterslug
      // You might need to get the first chapter slug from your API or use a default
      // For now, using the book slug as chapter slug
      return `/book/${book.seriesInfo.seriesSlug}/episode/${book.slug}`;
    } else {
      // For individual books: /book/:slug
      return `/book/${book.slug}`;
    }
  };

  const getDetailsLink = () => {
    if (hasSeries) {
      // For series: /book-details/:seriesId (using series ID for series details)
      return `/book-details/${book.slug}`;
    } else {
      // For individual books: /book-detail/:slug
      return `/book-detail/${book.slug}`;
    }
  };

  // Handle image click navigation
  const handleImageClick = () => {
    if (hasSeries) {
      navigate(`/book/${book.seriesInfo.seriesSlug}/episode/${book.slug}`);
    } else {
      navigate(`/book/${book.slug}`);
    }
  };

  return (
    <div className={styles.ebookCard}>
      <div className={styles.imageContainer}>
        <img
          src={book.image || "/placeholder-image.jpg"}
          alt={book.title}
          className={styles.coverImage}
          style={{ cursor: "pointer" }}
          onClick={handleImageClick}
        />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.categoryTag}>
          {book.category} | {book.tags && book.tags[0]}
        </div>
        <h2 className={styles.title}>{book.title}</h2>
        <p className={styles.summary}>{truncateSummary(book.summary)}</p>
        <div className={styles.actionButtons}>
          <Link to={getReadNowLink()} className={styles.readNowButton}>
            Read Now
          </Link>
          <Link to={getDetailsLink()} className={styles.detailsButton}>
            Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EbookCard;